import type { TrackingEvent, TrackingEventName } from "./TrackingApi";

const { fbq } = window;

export class MetaPixel {
  eventNames: Map<TrackingEventName, string>;

  currency: string;

  constructor({ currency }: { currency: string }) {
    this.currency = currency;

    this.eventNames = new Map([["addToWishlist", "AddToWishlist"]]);
  }

  async track({ eventName, product, variant }: TrackingEvent) {
    const eventAction = this.eventNames.get(eventName);

    if (!eventAction || typeof fbq !== "function" || !product) {
      return false;
    }

    fbq("track", eventAction, {
      value: variant?.price,
      currency: this.currency,
      content_ids: [product.id],
      content_name: [product.title, variant?.title]
        .filter((v) => !!v)
        .join(" - "),
      content_category: product.type,
      content_type: "product_group",
      num_items: 1,
    });

    return true;
  }
}
